import React from 'react'
import styles from './index.module.css'

interface CardProps {
    title?: string
    children?: React.ReactNode
}

export default function Card(props: CardProps) {
    return (
        <div className={styles.root}>
            { props.title &&
                <div className={styles.head}>
                    {props.title}
                </div>
            }
            <div className={styles.main}>
                {props.children}
            </div>
        </div>
    )
}